<template>
  <div
    v-click-outside="
      () => {
        showDropdown = false;
      }
    "
    class="multi-select-container"
    @click="enableTypeAhead"
  >
    <div class="select-input">
      <div class="wrapper">
        <data-tag
          v-for="t in selected"
          :key="t"
          :tag="t"
          class="sm"
          @delete="removeFromSelected($event)"
        />
        <input
          :id="`${fieldName}-multiSelect`"
          v-model="filteredOption"
          class="input-field"
          @input="showDropdown = true"
          @keypress.enter="addToSelected(filteredOption, true)"
          @keydown="handleBackspace($event)"
        />
      </div>
    </div>

    <div v-if="showDropdown" class="select-dropdown">
      <ul>
        <li
          v-for="item in itemList.filter(filterOnInput)"
          :key="item"
          :class="{ selected: isSelected(item) }"
          @click="addToSelected(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import DataTag from '@/app/components/DataTag';
import vClickOutside from 'v-click-outside';
export default {
  components: {
    DataTag
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    itemList: {
      type: Array,
      required: true
    },
    currentItems: {
      type: Array,
      default: null
    },
    fieldName: {
      type: String,
      default: 'tol'
    },
    filterOn: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      showDropdown: false,
      selected: [],
      isEditable: false,
      filteredOption: ''
    };
  },
  watch: {
    currentItems: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.selected = val.slice();
        }
      }
    }
  },
  methods: {
    filteredInputList(keyedInput) {
      return this.itemList
        .map(d => (this.filterOn ? this.filterOn(d) : d))
        .filter(val =>
          val
            .toString()
            .toLowerCase()
            .match(keyedInput.toLowerCase())
        );
    },

    enableTypeAhead() {
      const elId = `${this.fieldName}-multiSelect`;
      document.getElementById(elId).focus();
      this.showDropdown = !this.showDropdown;
    },
    handleBackspace(evt) {
      if (evt.key == 'Backspace' && this.selected.length && !this.filteredOption) {
        const oldSelected = [...this.selected];
        oldSelected.pop();
        this.selected = [...oldSelected];
        this.$emit('item-change', this.selected);
      }
    },
    addToSelected(val, keyed = false) {
      if (keyed) {
        let filteredList = this.filteredInputList(val);
        val = filteredList.length == 1 ? this.filteredInputList(val)[0] : '';
        if (!val) return;
      }
      this.showDropdown = false;
      let displayVal = this.filterOn ? this.filterOn(val) : val;
      if (!this.selected.includes(displayVal)) {
        const oldSelected = [...this.selected];
        oldSelected.push(displayVal);
        this.selected = [...oldSelected];
      }
      this.$emit('item-change', this.selected);
      this.filteredOption = '';
    },
    removeFromSelected(val) {
      const newSelected = this.selected.filter(item => item !== val);
      this.selected = [...newSelected];
      this.$emit('item-change', this.selected);
    },
    isSelected(val) {
      let displayVal = this.filterOn ? this.filterOn(val) : val;
      return this.selected.includes(displayVal);
    },
    filterOnInput(item) {
      let strToMatch;
      if (this.filteredOption) {
        strToMatch = this.filterOn ? this.filterOn(item) : item;
        return strToMatch
          .toString()
          .toLowerCase()
          .includes(this.filteredOption.toLowerCase());
      }
      return true;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.multi-select-container {
  position: relative;
  display: flex;
  flex-grow: 1;
  background-color: $white;

  &.blue {
    border: 1px solid $blue;
  }
  .select-input {
    display: flex;
    align-items: center;
    .wrapper {
      min-height: 38px;
      background-color: $white;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .input-field {
        height: 100%;
        border: 0;
        &:focus {
          outline: none;
        }
      }
    }
  }

  .select-dropdown {
    position: absolute;
    width: 100%;
    top: 100%;
    left: 0;
    z-index: 100;
    border: 0.5px solid $mid-grey-1;
    background-color: $white;
    max-height: 450px;
    overflow-y: scroll;
    > ul {
      list-style: none;
      margin: 0;
      padding: 0;
      > li {
        padding: 15px 15px;

        border-top: 1px solid $row-border;
        &:hover {
          cursor: pointer;
        }

        &.selected {
          color: $light-grey-2;
        }
      }
    }
  }
}
</style>
